import { __assign, __generator } from "tslib";
import { all, put, call, takeEvery } from 'redux-saga/effects';
import ddt from '@wix/da-ddt';
import { request } from '../../xhr';
import { isApiError } from '../../xhr/request';
import { getDeviationUrl } from '../../DeviationViews/_helpers';
import { saveTierAsDraft, publishTier, deleteTier, tierRequestError, tierRequestSuccess, } from './actions';
var logger = ddt.createLogger('tierpopup');
export function fakeResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        if (window.doError) {
            return {
                error: 'invalid_request',
                error_description: 'Not logged in.',
                status: 'error',
            };
        }
        logger.log('faking the response!');
        var deviationsByType = require('@wix/da-sample-data').deviationsByType; // eslint-disable-line global-require
        return __assign(__assign({}, deviationsByType.tiers[0]), ((options === null || options === void 0 ? void 0 : options.data) || {}));
    }
}
function redirectToDeviationPage(deviation) {
    if (window) {
        window.location.replace(getDeviationUrl(deviation));
    }
}
function handleSaveTier(_a) {
    var title = _a.title, description = _a.description, price = _a.price, benefits = _a.benefits, tags = _a.tags, accessSettings = _a.accessSettings, coverImage = _a.coverImage, _b = _a.showSubscriberCount, showSubscriberCount = _b === void 0 ? false : _b, _c = _a.messageTitle, messageTitle = _c === void 0 ? '' : _c, _d = _a.messageText, messageText = _d === void 0 ? '' : _d, _e = _a.tierId, tierId = _e === void 0 ? undefined : _e;
    var isUpdate = !!tierId;
    var url = isUpdate ? '/tier/update' : '/tier/create';
    var method = 'post';
    var data = {
        tierId: tierId,
        title: title,
        description: description,
        price: price,
        display_num_subscribers: showSubscriberCount,
        benefits: benefits,
        tags: tags,
        access_settings: accessSettings,
        thank_message_title: messageTitle,
        thank_message_body: messageText,
        cover_image_deviation_id: coverImage === null || coverImage === void 0 ? void 0 : coverImage.deviationId,
    };
    return call(request, {
        method: method,
        url: url,
        data: data,
    }, fakeResponse);
}
function publishTierSaga(action) {
    var tierId, createResponse, response;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                tierId = action.payload.tierId;
                logger.log('payload', action.payload);
                if (!!tierId) return [3 /*break*/, 6];
                return [4 /*yield*/, handleSaveTier(action.payload)];
            case 1:
                createResponse = _c.sent();
                if (!isApiError(createResponse)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(tierRequestError(createResponse.errorDescription))];
            case 2:
                _c.sent();
                return [2 /*return*/, true];
            case 3:
                if (!!((_b = (_a = createResponse === null || createResponse === void 0 ? void 0 : createResponse.deviation) === null || _a === void 0 ? void 0 : _a.tier) === null || _b === void 0 ? void 0 : _b.tierId)) return [3 /*break*/, 5];
                return [4 /*yield*/, put(tierRequestError('tierPopup.error.couldNotCreateTier'))];
            case 4:
                _c.sent();
                return [2 /*return*/];
            case 5:
                tierId = createResponse.deviation.tier.tierId;
                _c.label = 6;
            case 6: return [4 /*yield*/, call(request, {
                    method: 'post',
                    url: '/tier/publish',
                    data: {
                        tierid: tierId,
                    },
                })];
            case 7:
                response = _c.sent();
                if (!isApiError(response)) return [3 /*break*/, 9];
                return [4 /*yield*/, put(tierRequestError(response.errorDescription))];
            case 8:
                _c.sent();
                return [2 /*return*/, true];
            case 9:
                if (!!response.deviation) return [3 /*break*/, 11];
                return [4 /*yield*/, put(tierRequestError('tierPopup.error.couldNotPublishTier'))];
            case 10:
                _c.sent();
                return [2 /*return*/];
            case 11:
                window.location.reload();
                return [2 /*return*/];
        }
    });
}
function saveTierDraftSaga(action) {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                logger.log('saving', action.payload);
                return [4 /*yield*/, handleSaveTier(action.payload)];
            case 1:
                response = _a.sent();
                if (!(!response || !response.deviation)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(tierRequestError('tierPopup.error.couldNotSaveTier'))];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3:
                redirectToDeviationPage(response.deviation);
                return [2 /*return*/];
        }
    });
}
function deleteTierSaga(action) {
    var tierid, response;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                tierid = (_c = (_b = (_a = action === null || action === void 0 ? void 0 : action.payload) === null || _a === void 0 ? void 0 : _a.deviation) === null || _b === void 0 ? void 0 : _b.tier) === null || _c === void 0 ? void 0 : _c.tierId;
                logger.log('deleting', tierid);
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: "/tier/delete",
                        data: { tierid: tierid },
                    }, fakeResponse)];
            case 1:
                response = _d.sent();
                if (!isApiError(response)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(tierRequestError(response.errorDescription))];
            case 2:
                _d.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, put(tierRequestSuccess())];
            case 4:
                _d.sent();
                if (window) {
                    window.location.reload();
                }
                return [2 /*return*/];
        }
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeEvery(saveTierAsDraft, saveTierDraftSaga),
                    takeEvery(publishTier, publishTierSaga),
                    takeEvery(deleteTier, deleteTierSaga),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map